import React, { Component } from 'react'

import Select from 'react-select';

import TextEditor from '../TextEditor';
import _ from 'lodash'
import VideoImageFile from '../../component/VideoImageFile'
import ImageOnlyUpload from '../../pages/ImageOnlyUpload';
import VideoOnlyUpload from "../../pages/VideoOnlyUpload";

//import AWS from "aws-sdk";
import AWS from "aws-sdk";

//Service import
import service from "../../services";

//Validation import
import SimpleReactValidator from "simple-react-validator";

import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

// Slick Slider
import Slider from "react-slick";

//  Dat Picker
import DatePicker from "react-datepicker";

//moment import
import moment from "moment";

// Images import
import calendar from "../../assets/images/calendar.svg";
import addIcon from "../../assets/images/add.svg";
import minusIcon from "../../assets/images/minus.svg";
import addIconBorder from "../../assets/images/add-border.svg";
import dashIcon from "../../assets/images/dash.svg";
import { withRouter } from 'react-router-dom';
import PopUpCustomAll from '../fpg/create/popUpCustomAll';
import ErrorPopUp from '../errorPopUp';
import ModalMessage from '../ModalMessage';
import commonImage from '../../commonImage';

let sub

class ScreeningDisplayTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorPopup: false,
      messageModal: false,
      deleteId: '',
      isImage: false,
      startDate: new Date(),
      eventTitle: "",
      eventDisplayTemplate: "Screening",
      eventDescription: EditorState.createEmpty(),
      eventDetail: EditorState.createEmpty(),
      CTA: [],
      image1: null,
      featurePopup: false,
      titlePopup: false,
      availableThroughoutFestival: false,
      satelliteTitleEvent: false,
      selectPartnerFlag: false,
      imagePreloader: false,
      detailImageOrVideo: [{
        _id: Math.random(),
        link: '',
        url: ''
      },
      {
        _id: Math.random(),
        link: '',
        url: ''
      },
      {
        _id: Math.random(),
        link: '',
        url: ''
      }],

      //Screening Template Variable Declaration Start
      eventDates: [
        {
          id: Math.random(),
          date: new Date(),
          eventParticularTime: [
            {
              date: new Date(),
              id: Math.random(),
              start: {
                hours: { value: '7', label: '7' },
                mins: { value: '30', label: '30' },
                stamps: { value: 'AM', label: 'AM' }
              },
              end: {
                hours: { value: '8', label: '8' },
                mins: { value: '30', label: '30' },
                stamps: { value: 'AM', label: 'AM' }
              }
            }
          ],
          time: [
            {
              date: new Date(),
              id: Math.random(),
              start: {
                hours: { value: '7', label: '7' },
                mins: { value: '30', label: '30' },
                stamps: { value: 'AM', label: 'AM' }
              },
              end: {
                hours: { value: '8', label: '8' },
                mins: { value: '30', label: '30' },
                stamps: { value: 'AM', label: 'AM' }
              },
              activityDetails: ''
            }

          ],
        }
      ],
      // Screening Template Variable Declaration End

      satelliteTitleEvent: false,
      description1: "",
      partnerId: "",
      loaderFlag: false,
      partnerNameList: [],
      addedBy: '',
      deleteFeatureID: '',
      deleteTitleID: '',
      offerOutboundUrl: '',
      keyEventThumbnailImage: [{
        _id: Math.random(),
        link: "",
        url: ""
      }

      ]
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
  }

  componentDidMount = () => {
    this.getAllEvent();
    if (this.props.screeningUserID) {
      this.getPerticularEvent();
    }
    document.body.addEventListener('click', this.bodyClick);
  };

  componentWillUnmount = () => {
    sub.unsubscribe();
  }

  // Body Click
  bodyClick = (e) => {
    if (document.querySelector('.popup_wrapper')) {
      if (!e.target.closest('.popup_wrapper')) {
        this.setState({
          featurePopup: false,
          titlePopup: false
        })
      }
    }
  }

  /* Screening Session  Start*/
  addTimer = (parentId) => {
    this.setState({})
    var time =
    {
      date: new Date(),
      id: Math.random(),
      start: {
        hours: { value: '7', label: '7' },
        mins: { value: '30', label: '30' },
        stamps: { value: 'AM', label: 'AM' }
      },
      end: {
        hours: { value: '8', label: '8' },
        mins: { value: '30', label: '30' },
        stamps: { value: 'AM', label: 'AM' }
      },
      activityDetails: ''
    }

    this.state.eventDates.forEach(event => {
      if (event.id === parentId) {
        event.time.push(time)
      }
    });

  };

  removeTime = (parentId, childId) => {

    this.setState({})
    this.state.eventDates.forEach(event => {
      if (event.id === parentId) {
        event.time = event.time.filter(_ => _.id !== childId)
      }
    });

  };

  onChangeTime = (time, parentId, childId, timeZone, key) => {
    this.setState({})
    this.state.eventDates.forEach(event => {

      if (event.id === parentId) {
        event.time.forEach(eventTime => {
          if (eventTime.id === childId) {
            if (timeZone === 'Start') {
              if (key === 'Hours')
                eventTime.start.hours = time
              else if (key === 'Mins')
                eventTime.start.mins = time
              else
                eventTime.start.stamps = time
            }
            else if (timeZone === 'End') {
              if (key === 'Hours')
                eventTime.end.hours = time
              else if (key === 'Mins')
                eventTime.end.mins = time
              else
                eventTime.end.stamps = time
            } else {
              eventTime.activityDetails = time.target.value
            }
          };
        })
      }
    });
  };

  handleChange = (date, id) => {
    this.setState({})
    this.state.eventDates.forEach(event => {
      if (event.id === id) {
        event.date = date
      }
    });

  };

  onInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onChangeTimeEventTimeGeneral = (time, parentId, childId, timeZone, key) => {
    this.setState({})
    this.state.eventDates.forEach(event => {

      if (event.id === parentId) {
        event.eventParticularTime.forEach(eventTime => {
          if (eventTime.id === childId) {
            if (timeZone === 'Start') {
              if (key === 'Hours')
                eventTime.start.hours = time
              else if (key === 'Mins')
                eventTime.start.mins = time
              else
                eventTime.start.stamps = time
            }
            else {
              if (key === 'Hours')
                eventTime.end.hours = time
              else if (key === 'Mins')
                eventTime.end.mins = time
              else
                eventTime.end.stamps = time
            }
          }
        });
      }
    });
  };
  /* Screening Session  End*/

  getAllEvent = () => {
    const { getLoginRole } = this.props
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "FestivalVillage|Event|createEvent":
          if (!response.error) {
            this.apiserve.success('Event Created successfully.')
            this.props.history.push("/satellite-adminview");
          } else {
            this.setState({
              loaderFlag: false,
              errorPopup: true,
              errorMsg: response.data.error ? response.data.error : response.data
            })
          }
          break;
        case "FestivalVillage|SatelliteScreen|getSatelliteEventById":
          if (response.data.eventDescription) {
            const blocksFromHtml = htmlToDraft(response.data.eventDescription);
            const { contentBlocks, entityMap } = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
            const editorState = EditorState.createWithContent(contentState);
            this.setState({
              editorState: editorState,
            })
          }
          if (response.data.eventDetail) {
            const blocksFromHtml = htmlToDraft(response.data.eventDetail);
            const { contentBlocks, entityMap } = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
            const editorStateShort = EditorState.createWithContent(contentState);
            this.setState({
              editorStateShort: editorStateShort,
            })
          }

          var temp = []
          var time = []
          var dateTimeDate = []
          var timeContain = {}
          response.data && response.data.eventDate.map(item => {
            let hoursStart = moment(item.eventParticularTime[0].start).tz("US/Mountain").format('h');
            let minutesStart = moment(item.eventParticularTime[0].start).tz("US/Mountain").format('mm')
            let stateStart = moment(item.eventParticularTime[0].start).tz("US/Mountain").format('A')
            let yearstart = moment(item.eventParticularTime[0].start).tz("US/Mountain").format('YYYY')
            let monthstart = moment(item.eventParticularTime[0].start).tz("US/Mountain").format('MM') - 1
            let datestart = moment(item.eventParticularTime[0].start).tz("US/Mountain").format('DD')
            let hoursend = moment(item.eventParticularTime[0].end).tz("US/Mountain").format('h');
            let minutesend = moment(item.eventParticularTime[0].end).tz("US/Mountain").format('mm')
            let stateend = moment(item.eventParticularTime[0].end).tz("US/Mountain").format('A')
            let yearend = moment(item.eventParticularTime[0].end).tz("US/Mountain").format('YYYY')
            let monthend = moment(item.eventParticularTime[0].end).tz("US/Mountain").format('MM') - 1
            let dateend = moment(item.eventParticularTime[0].end).tz("US/Mountain").format('DD')
            var dateTime = {
              date: new Date(yearstart, monthstart, datestart),
              eventParticularTime: [{
                start: {
                  date: new Date(yearstart, monthstart, datestart),
                  hours: { value: hoursStart, label: hoursStart },
                  mins: { value: minutesStart, label: minutesStart },
                  stamps: { value: stateStart, label: stateStart }
                },
                end: {
                  date: new Date(yearend, monthend, dateend),
                  hours: { value: hoursend, label: hoursend },
                  mins: { value: minutesend, label: minutesend },
                  stamps: { value: stateend, label: stateend }
                }
              }],

            }
            item.time.map((timeList) => {
              let hoursTimeStart = moment(timeList.start).tz("US/Mountain").format('h');
              let minutesTimeStart = moment(timeList.start).tz("US/Mountain").format('mm')
              let stateTimeStart = moment(timeList.start).tz("US/Mountain").format('A')
              let yearTimestart = moment(timeList.start).tz("US/Mountain").format('YYYY')
              let monthTimestart = moment(timeList.start).tz("US/Mountain").format('MM') - 1
              let dateTimestart = moment(timeList.start).tz("US/Mountain").format('DD')

              let hoursTimeend = moment(timeList.end).tz("US/Mountain").format('h');
              let minutesTimeend = moment(timeList.end).tz("US/Mountain").format('mm')
              let stateTimeend = moment(timeList.end).tz("US/Mountain").format('A')

              timeContain = {
                date: new Date(yearTimestart, monthTimestart, dateTimestart),
                id: Math.random(),
                start: {
                  hours: { value: hoursTimeStart, label: hoursTimeStart },
                  mins: { value: minutesTimeStart, label: minutesTimeStart },
                  stamps: { value: stateTimeStart, label: stateTimeStart }
                },
                end: {
                  hours: { value: hoursTimeend, label: hoursTimeend },
                  mins: { value: minutesTimeend, label: minutesTimeend },
                  stamps: { value: stateTimeend, label: stateTimeend }
                },
                activityDetails: timeList.activityDetails
              }

              time.push(timeContain)
              dateTimeDate = { ...dateTime, time }
            })
            temp.push(dateTimeDate)
          })

          this.setState({
            eventDisplayTemplate: response.data.eventDisplayTemplate,
            eventId: response.data._id,
            eventTitle: response.data.eventTitle,
            displayType: response.data.displayType,
            eventDates: response.data.availableThroughoutFestival ? this.state.eventDates : temp,
            availableThroughoutFestival: response.data.availableThroughoutFestival,
            satelliteTitleEvent: response.data.satelliteTitleEvent,
            cta_title1:
              response.data._id ? response &&
                response.data &&
                response.data.CTA[0] &&
                response.data.CTA[0].title : '',
            cta_url1:
              response.data._id ? response &&
                response.data &&
                response.data.CTA[0] &&
                response.data.CTA[0].url : '',
            cta_description1:
              response.data._id ? response &&
                response.data &&
                response.data.CTA[1] &&
                response.data.CTA[1].description : '',
            cta_title2:
              response.data._id ? response &&
                response.data &&
                response.data.CTA[1] &&
                response.data.CTA[1].title : '',
            cta_url2:
              response.data._id ? response &&
                response.data &&
                response.data.CTA[1] &&
                response.data.CTA[1].url : '',
            keyEventThumbnailImage: response.data.keyEventThumbnailImage,
            detailImageOrVideo: response.data.detailImageOrVideo,
          });
          this.setState({ loaderFlag: false })
          break;
        case "FestivalVillage|Event|updateEvent":
          if (!response.error) {
            this.apiserve.success('Event Created successfully.')
            this.props.history.push("/satellite-adminview");
          } else {
            this.setState({
              errorPopup: true,
              loaderFlag: false,
              errorMsg: response.data.error ? response.data.error : response.data
            })
          }
        break;
        case "FestivalVillage|Event|Preview|create":
          if (!response.error) {
              this.setState({
                  loaderFlag:false,
              },()=>{
              window.open(process.env.REACT_APP_FRONTEND_ORIGIN_FESTIVAL_VILLAGE + 'film-preview');
              })
          }
          else
          {
              this.setState({
                  errorPopup:true,
                  errorMsg: response.data.error ? response.data.error : response.data 
              })
          }
        break;
      }
    });
  };

  errorMsgPopup = () => {
    this.setState({
      errorPopup: false
    })
  }

  getPerticularEvent = () => {
    const { screeningUserID } = this.props;
    this.apiserve.sendevent("FestivalVillage|SatelliteScreen|getSatelliteEventById", {
      id: screeningUserID,
    });
    this.setState({ loaderFlag: true })
  };

  getMtTime = (date) => {
    //Get offset from mountain time using UTC
    let offDifference = moment().utcOffset() + 420;

    // add that offset in date
    return moment(date).add(offDifference, 'minutes').toISOString()
  }

  eventDataCreateUpddate = () => {
    const { self } = this
    const name = this.state.editorState ? convertToRaw(this.state.editorState.getCurrentContent()) : ''
    const markup = draftToHtml(name);

    const nameShort = this.state.editorStateShort ? convertToRaw(this.state.editorStateShort.getCurrentContent()) : ''
    const markupShort = draftToHtml(nameShort);
    this.state.keyEventThumbnailImage.forEach(element => {
      delete element._id
    });

    this.state.detailImageOrVideo.forEach(element => {
      delete element._id
    });

    var eventDate = this.state && this.state.eventDates.map(item => {
      var eventDateList = new Date(item && item.date);
      eventDateList.setHours(item.eventParticularTime[0].start.stamps.value === 'PM' || item.eventParticularTime[0].start.stamps.value === 'pm' ? parseInt(item.eventParticularTime[0].start.hours.value) === 12 ? parseInt(item.eventParticularTime[0].start.hours.value) : parseInt(item.eventParticularTime[0].start.hours.value) + 12 : parseInt(item.eventParticularTime[0].start.hours.value) === 12 ? parseInt(item.eventParticularTime[0].start.hours.value) - 12 : parseInt(item.eventParticularTime[0].start.hours.value), item.eventParticularTime[0].start.mins.value);
      var eventDateListStart = this.getMtTime(eventDateList)
      eventDateList.setHours(item.eventParticularTime[0].end.stamps.value === 'PM' || item.eventParticularTime[0].end.stamps.value === 'pm' ? parseInt(item.eventParticularTime[0].end.hours.value) === 12 ? parseInt(item.eventParticularTime[0].end.hours.value) : parseInt(item.eventParticularTime[0].end.hours.value) + 12 : parseInt(item.eventParticularTime[0].end.hours.value) === 12 ? parseInt(item.eventParticularTime[0].end.hours.value) - 12 : parseInt(item.eventParticularTime[0].end.hours.value), item.eventParticularTime[0].end.mins.value);
      var eventDateListEnd = this.getMtTime(eventDateList)
      var time = []
      item.time.map((timeList) => {
        var timeListStart = new Date(timeList && timeList.date);
        timeListStart.setHours(timeList.start.stamps.value === 'PM' || timeList.start.stamps.value === 'pm' ? parseInt(timeList.start.hours.value) === 12 ? parseInt(timeList.start.hours.value) : parseInt(timeList.start.hours.value) + 12 : parseInt(timeList.start.hours.value) === 12 ? parseInt(timeList.start.hours.value) - 12 : parseInt(timeList.start.hours.value), timeList.start.mins.value)
        var timeDataStart = this.getMtTime(timeListStart)
        var timeListEnd = new Date(timeList && timeList.date);
        timeListEnd.setHours(timeList.end.stamps.value === 'PM' || timeList.end.stamps.value === 'pm' ? parseInt(timeList.end.hours.value) === 12 ? parseInt(timeList.end.hours.value) : parseInt(timeList.end.hours.value) + 12 : parseInt(timeList.end.hours.value) === 12 ? parseInt(timeList.end.hours.value) - 12 : parseInt(timeList.end.hours.value), timeList.end.mins.value)
        var timeDataEnd = this.getMtTime(timeListEnd)
        var temTime = {
          date: this.getMtTime(timeListStart),
          start: timeDataStart,
          end: timeDataEnd,
          activityDetails: timeList.activityDetails
        }
        time.push(temTime);
      })
      var eventParticularTime = [{
        date: this.getMtTime(eventDateList),
        start: eventDateListStart,
        end: eventDateListEnd
      }]
      var dateTime = {
        date: this.getMtTime(eventDateList),
        eventParticularTime: eventParticularTime,
        time: time
      }
      return dateTime
    })

    var result = _.filter(_.uniq(this.state.detailImageOrVideo, function(item, key, a) {
      return item._id;
    }), function(element) {
      return element.link || element.url
    });

    let data = {
      eventDisplayTemplate: this.props.eventDisplayTemplate ? this.props.eventDisplayTemplate : this.state.eventDisplayTemplate,
      eventTitle: this.state.eventTitle,
      eventDescription: markup,
      displayType: this.state.displayType,
      eventDetail: markupShort,
      satelliteTitleEvent: this.state.satelliteTitleEvent,
      eventDate: eventDate,
      eventTypeTitle: "satellite",
      availableThroughoutFestival: this.state.availableThroughoutFestival,
      CTA: [
        {
          title: this.state.cta_title1,
          url: this.state.cta_url1,
        },
        {
          description: this.state.cta_description1,
          title: this.state.cta_title2,
          url: this.state.cta_url2,
        },
      ],
      keyEventThumbnailImage: this.state.keyEventThumbnailImage,
      detailImageOrVideo: this.state.detailImageOrVideo,
      frontDetailImageOrVideo:result
    };

    if (this.state.eventId) data.id = this.state.eventId
    this.apiserve.sendevent(this.state.eventId ? "FestivalVillage|Event|updateEvent" : "FestivalVillage|Event|createEvent", data);
  }

  previewRecord = (e) => {
    e.preventDefault()
    let previewDetails = {}
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
        const name = this.state.editorState ? convertToRaw(this.state.editorState.getCurrentContent()) : ''
        const markup = draftToHtml(name);
    
        const nameShort = this.state.editorStateShort ? convertToRaw(this.state.editorStateShort.getCurrentContent()) : ''
        const markupShort = draftToHtml(nameShort);
    
        var eventDate = this.state && this.state.eventDates.map(item => {
          var eventDateList = new Date(item && item.date);
          eventDateList.setHours(item.eventParticularTime[0].start.stamps.value === 'PM' || item.eventParticularTime[0].start.stamps.value === 'pm' ? parseInt(item.eventParticularTime[0].start.hours.value) === 12 ? parseInt(item.eventParticularTime[0].start.hours.value) : parseInt(item.eventParticularTime[0].start.hours.value) + 12 : parseInt(item.eventParticularTime[0].start.hours.value) === 12 ? parseInt(item.eventParticularTime[0].start.hours.value) - 12 : parseInt(item.eventParticularTime[0].start.hours.value), item.eventParticularTime[0].start.mins.value);
          var eventDateListStart = this.getMtTime(eventDateList)
          eventDateList.setHours(item.eventParticularTime[0].end.stamps.value === 'PM' || item.eventParticularTime[0].end.stamps.value === 'pm' ? parseInt(item.eventParticularTime[0].end.hours.value) === 12 ? parseInt(item.eventParticularTime[0].end.hours.value) : parseInt(item.eventParticularTime[0].end.hours.value) + 12 : parseInt(item.eventParticularTime[0].end.hours.value) === 12 ? parseInt(item.eventParticularTime[0].end.hours.value) - 12 : parseInt(item.eventParticularTime[0].end.hours.value), item.eventParticularTime[0].end.mins.value);
          var eventDateListEnd = this.getMtTime(eventDateList)
          var time = []
          item.time.map((timeList) => {
            var timeListStart = new Date(timeList && timeList.date);
            timeListStart.setHours(timeList.start.stamps.value === 'PM' || timeList.start.stamps.value === 'pm' ? parseInt(timeList.start.hours.value) === 12 ? parseInt(timeList.start.hours.value) : parseInt(timeList.start.hours.value) + 12 : parseInt(timeList.start.hours.value) === 12 ? parseInt(timeList.start.hours.value) - 12 : parseInt(timeList.start.hours.value), timeList.start.mins.value)
            var timeDataStart = this.getMtTime(timeListStart)
            var timeListEnd = new Date(timeList && timeList.date);
            timeListEnd.setHours(timeList.end.stamps.value === 'PM' || timeList.end.stamps.value === 'pm' ? parseInt(timeList.end.hours.value) === 12 ? parseInt(timeList.end.hours.value) : parseInt(timeList.end.hours.value) + 12 : parseInt(timeList.end.hours.value) === 12 ? parseInt(timeList.end.hours.value) - 12 : parseInt(timeList.end.hours.value), timeList.end.mins.value)
            var timeDataEnd = this.getMtTime(timeListEnd)
            var temTime = {
              date: this.getMtTime(timeListStart),
              start: timeDataStart,
              end: timeDataEnd,
              activityDetails: timeList.activityDetails
            }
            time.push(temTime);
          })
          var eventParticularTime = [{
            date: this.getMtTime(eventDateList),
            start: eventDateListStart,
            end: eventDateListEnd
          }]
          var dateTime = {
            date: this.getMtTime(eventDateList),
            eventParticularTime: eventParticularTime,
            time: time
          }
          return dateTime
        })
    
        var result = _.filter(_.uniq(this.state.detailImageOrVideo, function(item, key, a) {
          return item._id;
        }), function(element) {
          return element.link || element.url
        });

        previewDetails = {
          eventDisplayTemplate: this.props.eventDisplayTemplate ? this.props.eventDisplayTemplate : this.state.eventDisplayTemplate,
          eventTitle: this.state.eventTitle,
          eventDescription: markup,
          displayType: this.state.displayType,
          eventDetail: markupShort,
          satelliteTitleEvent: this.state.satelliteTitleEvent,
          eventDate: eventDate,
          eventTypeTitle: "satellite",
          availableThroughoutFestival: this.state.availableThroughoutFestival,
          CTA: [
            {
              title: this.state.cta_title1,
              url: this.state.cta_url1,
            },
            {
              description: this.state.cta_description1,
              title: this.state.cta_title2,
              url: this.state.cta_url2,
            },
          ],
          keyEventThumbnailImage: this.state.keyEventThumbnailImage,
          detailImageOrVideo: this.state.detailImageOrVideo,
          frontDetailImageOrVideo:result
        };
        if (this.state.eventId) previewDetails.id = this.state.eventId
        let previewString = this.apiserve.encrypt(previewDetails)
        this.apiserve.sendevent("FestivalVillage|Event|Preview|create", {previewString}); 
    } else {
      this.setState({
        messageModal: true,
      })
      this.validator.showMessages();
      this.forceUpdate();
    }
}


  submitFn = (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      this.eventDataCreateUpddate();
    } else {
      this.setState({
        messageModal: true,
      })
      this.validator.showMessages();
      this.forceUpdate();
    }
  };
  ClosemessageModal = () => {
    this.setState({
      messageModal: false,
    })
  }

  //Partner Title Event Start
  satelliteTitleEventCheck = (e) => {
    const { getLoginRole } = this.props;
    this.setState({
      satelliteTitleEvent: e.target.checked
    })
  }

  //Partner Title Event Start
  availableThroughoutFestival = (e) => {
    const { getLoginRole } = this.props;
    this.setState({
      availableThroughoutFestival: e.target.checked
    })
  }

  cancelFn = () => {
    this.props.history.push('/satellite-adminview')
  };


  onEditorStateDescription = (editorState) => {
    this.setState({ editorState });
  };

  onEditorStateDetail = (editorStateShort) => {
    this.setState({ editorStateShort });
  };

  handleImage(e, id) {
    e.stopPropagation()
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {
      this.setState({
        file: file,
      }, () => {
        const fileList = Math.round((file && file.size / 1024));
        if (fileList >= 2048) {
          this.setState({
            errorPopup: true,
            errorMsg: 'Please upload a file smaller than 2 MB'
          })
          return false;
        }
        if (file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg') {
          setTimeout(() => {
            this.imageUploadOne(file, id,event.target.result);
          }, 0)
        } else {
          this.setState({
            errorPopup: true,
            errorMsg: 'Please upload a file for PNG,JPG or JPEG'
          })
        }
      })
    }
  }

  imageUploadOne = (file, id, img) => {
    const imagePreloaderId = `imagePreloader_${id}`
    const newState = { ...this.state }
    newState[imagePreloaderId] = true
    this.setState(newState)
    var fileSet= commonImage(file,false,'',img)
     fileSet.then((value) => {
        this.state.keyEventThumbnailImage.forEach(image => {

          const imagePreloaderId = `imagePreloader_${id}`
          const newState = { ...this.state }
          newState[imagePreloaderId] = false
          this.setState(newState)
          if (image._id === id) {

            image.link = value
          }

        });
        this.setState({})
      });
  };

  OnchangeImage = (e, id) => {
    const { name, value } = e.target
    this.state.keyEventThumbnailImage.forEach(image => {
      if (image._id === id) {
        image.url = value
      }

    });
    this.setState({})

  }

  onChangeFile = (e, id) => {
    e.stopPropagation();
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {
      this.setState({
        file: file
        // base64: reader.result
      });
      if (
        (file && file.type === "image/png") ||
        (file && file.type === "image/jpg") ||
        (file && file.type === "image/jpeg")
      ) {
        const fileList = Math.round((file && file.size / 1024));
        if (fileList >= 2048) {
          this.setState({
            errorPopup: true,
            errorMsg: 'Please upload a file smaller than 2 MB'
          })
          return false;
        }
        if (file && (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
          // this.setState({ isImage: true })

          setTimeout(() => {
            this.uploadVideoImage(file, id,event.target.result);
          }, 0)
        } else {
          this.setState({
            errorPopup: true,
            errorMsg: 'Please Upload PNG/JPEG of max size of 2MB OR MP4 of max size 200MB'
          })
        }
      } else {
        if (file.size > 200e6) {
          this.setState({
            errorPopup: true,
            errorMsg: "Please upload a video smaller than 200 MB"
          });
          return false;
        }

        if (file.type === "video/mp4") {

          setTimeout(() => {
            this.uploadVideoImage(file, id,event.target.result);
          }, 0);
          return false;
        } else {
          this.setState({
            errorPopup: true,
            errorMsg: "Please Upload PNG/JPEG of max size of 2MB OR MP4 of max size 200MB"
          });
        }
      }
    };
  };

  uploadVideoImage = (file, id, img) => {
    const imagePreloaderId = `imagePreloader_${id}`;
    const newState = { ...this.state, videoPreLoader: true };
    newState[imagePreloaderId] = true;
    this.setState(newState);
    var fileSet= commonImage(file,false,'',img)
     fileSet.then((value) => {
      this.state.detailImageOrVideo.forEach(image => {
        const imagePreloaderId = `imagePreloader_${id}`;
        const newState = { ...this.state };
        newState[imagePreloaderId] = false;
        this.setState(newState);

        if (image._id === id) {

          image.link = value;
        }
      });
      this.setState({});
    });
  };

  insideFilechange = (e, id) => {
    const { name, value } = e.target
    this.state.detailImageOrVideo.forEach(image => {
      if (image._id === id) {

        image.url = value;
      }
    });
    this.setState({})
  }

  setDeleteImagePopup = (e, id) => {
    this.setState({
      deleteImagePopup: true,
      deleteId: id
    })
  }

  onDeleteImagePopup = () => {
    this.state.keyEventThumbnailImage.forEach(image => {
      if (image._id === this.state.deleteId) {
        image.link = "";
      }
    });

    this.state.detailImageOrVideo.forEach(image => {
      if (image._id === this.state.deleteId) {
        image.link = "";
      }
    });

    this.setState({
      deleteImagePopup: false
    })
  }

  closeAdminUser = () => {
    this.setState({ deleteImagePopup: false })
  };


  render() {
    var settings = {
      customPaging: function (i) {
        return <a>{i + 1}</a>;
      },
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };

    const Hours = [
      { value: '12', label: '12' },
      { value: '1', label: '1' },
      { value: '2', label: '2' },
      { value: '3', label: '3' },
      { value: '4', label: '4' },
      { value: '5', label: '5' },
      { value: '6', label: '6' },
      { value: '7', label: '7' },
      { value: '8', label: '8' },
      { value: '9', label: '9' },
      { value: '10', label: '10' },
      { value: '11', label: '11' },
    ]

    const Mins = [
      { value: '00', label: '00' },
      { value: '15', label: '15' },
      { value: '20', label: '20' },
      { value: '25', label: '25' },
      { value: '30', label: '30' },
      { value: '35', label: '35' },
      { value: '40', label: '40' },
      { value: '45', label: '45' },
      { value: '50', label: '50' },
      { value: '55', label: '55' },
    ]

    const Stamps = [
      { value: 'AM', label: 'AM' },
      { value: 'PM', label: 'PM' }
    ]

    const { eventDisplayTemplate, eventDates, eventDatesScreen, availableThroughoutFestival } = this.state;
    return (
      <section id="Screening" className="screenigBlock_wrapper tab-panel">
        <form>
          <div className="EventTitle_block">
            <div className="textarea_block form_group">
              <h5 className="left_label required">Event Title</h5>
              <div className="form_group_textarea">
                <input
                  type="text"
                  name="eventTitle"
                  id="eventTitle"
                  value={this.state.eventTitle}
                  onChange={this.onInputChange}
                  autoComplete="off"
                />
                <span className="error">
                  {this.validator.message(
                    "event title",
                    this.state.eventTitle,
                    "required"
                  )}
                </span>
              </div>
              <div className="eventDate_block">
                <h5 className="left_label"></h5>
                <div className="customCheck">
                  <div className="customCheckBox">
                    <input
                      type="checkbox"
                      id="satelliteTitleEvent"
                      value={this.state.satelliteTitleEvent}
                      checked={this.state.satelliteTitleEvent}
                      onClick={(e) => this.satelliteTitleEventCheck(e, "satelliteTitleEvent")}
                    />
                    <label htmlFor="satelliteTitleEvent">
                      Satellite Title Event
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="description_block">
            <div className="textarea_block form_group">
              <h5 className="left_label required">Event Description </h5>
              <div className="form_group_textarea editor_wrapper ml_25 editor_400">
                <TextEditor
                  name="editorState"
                  editorState={this.state.editorState}
                  value={this.state.editorState}
                  onEditorStateChange={(e) => this.onEditorStateDescription(e)} />
                  <span className="error ml_0"> {this.validator.message( "Event Description", this.state.editorState, "required" )} </span>
              </div>
            </div>
            <div className="textarea_block form_group">
              <h5 className="required">Event Detail</h5>
              <div className="form_group_textarea editor_wrapper ml_25 editor_400">
                <TextEditor
                  name="editorStateShort"
                  editorState={this.state.editorStateShort}
                  value={this.state.editorStateShort}
                  onEditorStateChange={(e) => this.onEditorStateDetail(e)} />
                  <span className="error ml_0"> {this.validator.message( "Event Detail", this.state.editorStateShort, "required" )} </span>
              </div>
            </div>
          </div>
          <div className="eventDate_block">
            <h5 className="left_label"></h5>
            <div className="customCheck">
              <div className="customCheckBox">
                <input
                  type="checkbox"
                  id="availableThroughoutFestival"
                  value={this.state.availableThroughoutFestival}
                  checked={this.state.availableThroughoutFestival}
                  onClick={(e) => this.availableThroughoutFestival(e, "availableThroughoutFestival")}
                />
                <label htmlFor="availableThroughoutFestival">
                  Available Throughout Festival
              </label>
              </div>
            </div>
          </div>
          {availableThroughoutFestival ? '' :
            <div className="eventDate_block_Wrapper">
              <h5 className="left_label">Event Date</h5>
              <div className="eventData_block">

                {/* Screening Event Start */}
                <>
                  {eventDates && eventDates.map((x, i) => {
                    return (
                      <>
                        <div className="event-data-block-main" key={i}>
                          <div className="event-title-block">
                            <input
                              type="text"
                              id={x.id}
                              value={moment(
                                x.date
                              ).format("MM/DD/YYYY")}
                              placeholder="mm / dd / yyyy"
                            />
                            <DatePicker
                              selected={this.state.startDate}
                              onChange={(e) => this.handleChange(e, x.id)}
                              minDate={moment().toDate()}
                              placeholder="mm/dd/yyyy"
                              customInput={
                                <img
                                  src={calendar}
                                  className="calendar"
                                />
                              }
                            />
                          </div>
                          <div className="event-time-main-wpr">
                            <div className="event-time-section">
                              <h5>Event Time (MT)</h5>

                              <div className="event-time-main">

                                {x.eventParticularTime ?
                                  x.eventParticularTime.map((xTime, i) => {
                                    return (
                                      <div
                                        className="onClickPlus"
                                        key={i}
                                      >
                                        <div className="event-time-block">
                                          <Select
                                            id={xTime.id}
                                            value={xTime.start.hours}
                                            options={Hours}
                                            placeholder="7"
                                            onChange={(e) =>
                                              this.onChangeTimeEventTimeGeneral(e, x.id, xTime.id, 'Start', 'Hours')
                                            } />
                                          <Select
                                            value={xTime.start.mins}
                                            options={Mins}
                                            placeholder="30"
                                            onChange={(e) =>
                                              this.onChangeTimeEventTimeGeneral(e, x.id, xTime.id, 'Start', 'Mins')
                                            } />
                                          <Select
                                            value={xTime.start.stamps}
                                            options={Stamps}
                                            placeholder="AM"
                                            onChange={(e) =>
                                              this.onChangeTimeEventTimeGeneral(e, x.id, xTime.id, 'Start', 'Stamps')
                                            } />

                                          <span>
                                            <img src={dashIcon} />
                                          </span>

                                          <Select
                                            value={xTime.end.hours}
                                            options={Hours}
                                            placeholder="7"
                                            onChange={(e) =>
                                              this.onChangeTimeEventTimeGeneral(e, x.id, xTime.id, 'End', 'Hours')
                                            } />
                                          <Select
                                            value={xTime.end.mins}
                                            options={Mins}
                                            placeholder="30"
                                            onChange={(e) =>
                                              this.onChangeTimeEventTimeGeneral(e, x.id, xTime.id, 'End', 'Mins')
                                            } />
                                          <Select
                                            value={xTime.end.stamps}
                                            options={Stamps}
                                            placeholder="AM"
                                            onChange={(e) =>
                                              this.onChangeTimeEventTimeGeneral(e, x.id, xTime.id, 'End', 'Stamps')
                                            } />

                                        </div>
                                      </div>
                                    );
                                  })
                                  : ''
                                }

                              </div>
                            </div>
                            <div className="event-time-section">

                              <h5>Activity Time (MT)</h5>
                              <div className="event-time-main">
                                {x && (x.time.map((xTime, i) => {
                                  return (
                                    <div
                                      className="onClickPlus"
                                      key={i}
                                    >
                                      <div className="event-time-block">
                                        <Select
                                          id={xTime.id}
                                          value={xTime.start.hours}
                                          options={Hours}
                                          placeholder="7"
                                          onChange={(e) =>
                                            this.onChangeTime(e, x.id, xTime.id, 'Start', 'Hours')
                                          } />
                                        <Select
                                          value={xTime.start.mins}
                                          options={Mins}
                                          placeholder="30"
                                          onChange={(e) =>
                                            this.onChangeTime(e, x.id, xTime.id, 'Start', 'Mins')
                                          } />
                                        <Select
                                          value={xTime.start.stamps}
                                          options={Stamps}
                                          placeholder="AM"
                                          onChange={(e) =>
                                            this.onChangeTime(e, x.id, xTime.id, 'Start', 'Stamps')
                                          } />

                                        <span>
                                          <img src={dashIcon} />
                                        </span>

                                        <Select
                                          value={xTime.end.hours}
                                          options={Hours}
                                          placeholder="7"
                                          onChange={(e) =>
                                            this.onChangeTime(e, x.id, xTime.id, 'End', 'Hours')
                                          } />
                                        <Select
                                          value={xTime.end.mins}
                                          options={Mins}
                                          placeholder="30"
                                          onChange={(e) =>
                                            this.onChangeTime(e, x.id, xTime.id, 'End', 'Mins')
                                          } />
                                        <Select
                                          value={xTime.end.stamps}
                                          options={Stamps}
                                          placeholder="AM"
                                          onChange={(e) =>
                                            this.onChangeTime(e, x.id, xTime.id, 'End', 'Stamps')
                                          } />

                                      </div>
                                      <div className="event-activity-block">
                                        <input
                                          type="text"
                                          placeholder="Activity Details"
                                          name={xTime.activityDetails}
                                          id={xTime.id}
                                          value={xTime.activityDetails}
                                          onChange={(e) => this.onChangeTime(e, x.id, xTime.id, 'Activity')}
                                          autoComplete="off"
                                        />
                                      </div>
                                      {i === 0 ? (
                                        <>
                                          <a
                                            onClick={() =>
                                              this.addTimer(x.id)
                                            }
                                          >
                                            <img src={addIcon} />
                                          </a>
                                          <img
                                            src={addIconBorder}
                                            className="border"
                                          />
                                        </>
                                      ) : (
                                          <a
                                            onClick={() => this.removeTime(x.id, xTime.id)}
                                          >
                                            <img src={minusIcon} />
                                          </a>
                                        )}
                                    </div>
                                  );
                                })
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })}
                </>
                {/* Screening Event End */}
              </div>
            </div>
          }

          <div className="cta_block_wrapper">
            <div className="cta_title from_group">
              <h5 className="left_label required">Join Button Title</h5>
              <div className="from_group_input">
                <input
                  type="text"
                  type="cta_title1"
                  name="cta_title1"
                  id="cta_title1"
                  value={this.state.cta_title1}
                  onChange={this.onInputChange}
                  autoComplete="off"
                />
                <span className="error">
                  {this.validator.message(
                    "cta 1 title",
                    this.state.cta_title1,
                    "required"
                  )}
                </span>
              </div>
            </div>
            <div className="cta_url from_group">
              <h5 className="left_label required">Join Button URL</h5>
              <div className="from_group_input">
                <input
                  type="text"
                  name="cta_url1"
                  id="cta_url1"
                  value={this.state.cta_url1}
                  onChange={this.onInputChange}
                  autoComplete="off"
                />
                <span className="error">
                  {this.validator.message(
                    "cta 1 url",
                    this.state.cta_url1,
                    "required"
                  )}
                </span>
              </div>
            </div>
            <div className="textarea_block from_group">
              <h5 className="left_label required">
                Above CTA 2 Description
            </h5>
              <div className="from_group_input">
                <textarea
                  name="cta_description1"
                  id="cta_description1"
                  value={this.state.cta_description1}
                  onChange={this.onInputChange}
                ></textarea>
                <span className="error"> {this.validator.message( "cta 2 Description", this.state.cta_description1, "required" )} </span>
              </div>
            </div>
            <div className="cta_title from_group">
              <h5 className="left_label required">CTA 2 Title</h5>
              <div className="from_group_input">
                <input
                  type="text"
                  name="cta_title2"
                  id="cta_title2"
                  value={this.state.cta_title2}
                  onChange={this.onInputChange}
                  autoComplete="off"
                />
                <span className="error"> {this.validator.message( "cta 2 Title", this.state.cta_title2, "required" )} </span>

              </div>
            </div>
            <div className="cta_url from_group">
              <h5 className="left_label required">CTA 2 URL</h5>
              <div className="from_group_input">
                <input
                  type="text"
                  name="cta_url2"
                  id="cta_url2"
                  value={this.state.cta_url2}
                  onChange={this.onInputChange}
                  autoComplete="off"
                />
                <span className="error"> {this.validator.message( "cta 2 url", this.state.cta_url2, "required|url" )} </span>
              </div>
            </div>
          </div>

          <div className="EventTitle_block">
            <div className="textarea_block form_group mr_25">
              <h5 className="left_label">Detail Images or Videos</h5>
            </div>
            <div className="video_slider uploads_files mb_25" style={{ display: "block" }}>
              <Slider {...settings}>
                {this.state.detailImageOrVideo.map((item, i) => {
                  const imagePreloaderState = `imagePreloader_${item._id}`;
                  return (
                    this.state.isImage ||
                      item.link.match(/\.(jpeg|jpg|gif|png|jfif)$/) != null || item.url.match(/\.(jpeg|jpg|gif|png|jfif)$/) != null
                      ?
                      <div className="uploads_files file_upload_400 relative">
                      <VideoImageFile
                        item={item._id}
                        handleImage={(e) => this.onChangeFile(e, item._id)}
                        iconDelete={true}
                        size="2"
                        id={item._id}
                        image={item.url}
                        showDeleteIcon={item.link}
                        value={item.link ? this.apiserve.imageUrl + item.link : item.url}
                        insideOnchange={(e) => this.insideFilechange(e, item._id)}
                        videoPreLoader={this.state[imagePreloaderState]}
                        deleteImage={(e) => this.setDeleteImagePopup(e, item._id)}
                        isboth={true} 
                        textChange={true} />
                    </div>
                      :
                      <div className="uploads_files file_upload_400 relative">
                      <VideoOnlyUpload
                        handleVideo={(e) => this.onChangeFile(e, item._id)}
                        url={item.link ? `${this.apiserve.imageUrl}${item.link}` : item.url}
                        video={item.link ? `${this.apiserve.imageUrl}${item.link}` : item.url}
                        videoUrl={item.url}
                        insideOnchange={(e) => this.insideFilechange(e, item._id)}
                        item={item}
                        iconDelete={true}
                        showDeleteIcon={item.link}
                        videoPreLoader={this.state[imagePreloaderState]}
                        deleteVideo={(e) => this.setDeleteImagePopup(e, item._id)}
                        uploadmessage="Upload PNG/JPEG of max size of 2MB OR MP4 of max size 200MB"
                      />
                    </div>
                     
                      
                  );
                })}
              </Slider>
            </div>
          </div>
          <div className="EventTitle_block">
            <div className="textarea_block form_group mr_25">
              <h5 className="left_label">Key Event Thumbnail Image</h5>
            </div>
            {this.state.keyEventThumbnailImage &&
              this.state.keyEventThumbnailImage.map((item, index) => {
                const imagePreloaderState = `imagePreloader_${item._id}`
                return (
                  <div className="file_upload_400">
                    <div className="uploads_files">
                      <ImageOnlyUpload
                        item={item._id}
                        handleImage={(e) => this.handleImage(e, item._id)}
                        deleteImage={(e) => this.setDeleteImagePopup(e, item._id)}
                        iconDelete={true}
                        showDeleteIcon={item.link}
                        size="2"
                        id={item._id}
                        image={item.url}
                        value={item.link ? `${this.apiserve.imageUrl}${item.link}` : item.url}
                        ImagePreLoader={this.state[imagePreloaderState]}
                        insideOnchange={(e) => this.OnchangeImage(e, item._id)}
                        isboth={false}
                      />
                    </div>
                  </div>
                )
              })}
          </div>
          <div className="text_center field_row w_100 buttons_outer mb_0">
            <button
              className="grayBTN"
              type="button"
              onClick={() => this.cancelFn()}
            >
              Cancel
          </button>
            {/* <button className="uppercase prev_btn" type='button' onClick={(e)=>this.previewRecord(e)}>PREviEW</button> */}
            <button
              className="orangeBTN"
              type="button"
              disabled={this.state.imagePreloader ? true : false}
              onClick={this.submitFn}
            >
              Submit
          </button>
          </div>
        </form>
        {this.state.deleteImagePopup
          ? <PopUpCustomAll
            HeaderName="Delete Image?"
            insideDetails="Are You Sure ?"
            insideData="You want to delete this image"
            popupState={() => this.closeAdminUser()}
            yesPopUp={() => this.onDeleteImagePopup()} />
          : ""
        }

        {this.state.errorPopup ?
          <ErrorPopUp
            errorMsg={this.state.errorMsg}
            errorMsgPopup={this.errorMsgPopup}
          />
          : ''
        }
        {this.state.messageModal &&
          <ModalMessage messageModal={this.state.messageModal} withoutEmail="Few or all of the required fields are missing. Please scroll up and check to add and confirm and resubmit" ClosemessageModal={this.ClosemessageModal} />
        }
      </section>
    )
  }
}

export default withRouter(ScreeningDisplayTemplate)
